/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  padding-top: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.p`
  color: ${Palette.PrimaryGray._900};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
`;

export const Text = styled.p`
  color: ${Palette.PrimaryGray._700};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;
